import { useState } from "react";
import { toast } from "sonner";
import { Loader2, X, Ban } from "lucide-react";

export const CancelBookingDialog = ({ booking, requireEmail, onConfirm, onClose }) => {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const inputCls =
    "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none transition-all focus:border-red-500 focus:ring-1 focus:ring-red-500";
  const labelCls = "mb-1 block text-xs font-semibold text-[#0F172A]";

  const handleConfirm = async () => {
    if (requireEmail && !email.trim()) {
      toast.error("Enter the email used to make this booking");
      return;
    }
    if (!reason.trim()) {
      toast.error("Cancellation reason is required");
      return;
    }
    setSaving(true);
    try {
      await onConfirm({ email: email.trim(), reason: reason.trim() });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to cancel booking");
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="cancel-dialog">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-[#0F172A]">
            <Ban className="h-5 w-5 text-red-500" /> Cancel {booking.booking_ref}
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600" data-testid="cancel-dialog-close">
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="mb-4 text-xs text-[#64748B]">{booking.vehicle} &middot; {booking.employee_name}</p>

        <div className="space-y-4">
          {requireEmail && (
            <div>
              <label className={labelCls}>Confirm your booking email <span className="text-red-500">*</span></label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email used for this booking"
                className={inputCls}
                data-testid="cancel-email"
              />
            </div>
          )}
          <div>
            <label className={labelCls}>Cancellation reason <span className="text-red-500">*</span></label>
            <textarea
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Why is this booking being cancelled?"
              className={`${inputCls} resize-none`}
              data-testid="cancel-reason"
            />
          </div>
        </div>

        <div className="mt-6 flex gap-3">
          <button onClick={onClose} className="flex-1 rounded-lg border border-slate-300 px-4 py-2.5 text-sm font-semibold text-[#0F172A] transition-all hover:bg-slate-50" data-testid="cancel-dialog-back">
            Keep booking
          </button>
          <button onClick={handleConfirm} disabled={saving} className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white transition-all hover:bg-red-700 active:scale-[0.98] disabled:opacity-60" data-testid="cancel-confirm">
            {saving ? <><Loader2 className="h-4 w-4 animate-spin" /> Cancelling…</> : "Cancel booking"}
          </button>
        </div>
      </div>
    </div>
  );
};
